import { Controller } from "@hotwired/stimulus"

// Handles modals loaded via Turbo Frames.
// Closing clears the frame content and restores body scroll.
export default class extends Controller {
  connect() {
    document.body.classList.add("overflow-hidden")
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  close() {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.innerHTML = ""
      frame.removeAttribute("src")
    }
  }
}
